import { Card, List } from '@mairistem/composants';
import React from 'react';
import type Projet from '../../../interfaces/common/projet';
import { renderLabel } from '../../../utils/autorisation';
import './ActivitePanel.css';

interface ActivitePanelProps {
	data: Pick<Projet, 'description' | 'identifiant' | 'libelle' | 'statut'>[];
}

const ActivitePanel = ({ data }: ActivitePanelProps) => (
	<Card fluid>
		<Card.Content>
			<Card.Header content="Activité récente" />
			<Card.Description>
				<List className="activitePanelList" divided relaxed="very" size="large">
					{data.map((autorisation: Projet) => (
						<List.Item key={autorisation.identifiant}>
							<List.Content
								content={renderLabel(autorisation.statut)}
								floated="right"
								verticalAlign="middle"
							/>
							<List.Content>
								<List.Header content={autorisation.libelle} />
								<br />
								<List.Description content={autorisation.code} />
							</List.Content>
						</List.Item>
					))}
				</List>
			</Card.Description>
		</Card.Content>
	</Card>
);

export default ActivitePanel;
